import { Box } from '@mui/material'
import React from 'react'

import {
  DONUT_WIDTH,
  RELIABILITY_REPORT_COLORS
} from 'components/reliability-management/reliability-management-utils'
import DonutChart from 'components/reports/DonutChart'

const DONUT_HEIGHT = 200
const DONUT_RADIUS = 55

export interface DonutData {
  gremlin: string
  count: number
}

export const ReliabilityDonut: React.FC<{
  data: DonutData[]
  total: number
  headerText?: string
  textLine1?: string
  textLine2?: string
  wrapperId?: string
}> = ({ data, total, wrapperId, ...rest }) => {
  return (
    <Box data-testid={`${wrapperId ?? 'reliability-donut'}-wrapper`}>
      <DonutChart
        displaySingleData
        overrideDefaultSvgHeight
        colorMap={RELIABILITY_REPORT_COLORS}
        height={DONUT_HEIGHT}
        radius={DONUT_RADIUS}
        reportData={data}
        rootId={`#${wrapperId ?? 'reliability-donut-donut'}`}
        total={total}
        translate={{ left: 0, top: 0 }}
        variant="progress"
        width={DONUT_WIDTH}
        {...rest}
      />
    </Box>
  )
}
